// Riwayat Selesai Pantau Produksi Offline — nota yang sudah diterima Shella / diambil tetap bisa dicari (baca-saja, 20/halaman).
import { useEffect, useState } from "react";
import axios from "axios";
import { History, Search, ChevronRight } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;
const fmt = (iso) => iso ? new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) + " WIB" : "";

export const NOTA_LABEL = { "Menunggu Finalisasi": "Di Shella (menunggu diterima)", "Selesai": "Selesai di Shella" };
export const notaLabel = (s) => NOTA_LABEL[s] || s || "-";

export function ShellaStatusLine({ s, testid }) {
  if (!s) return null;
  if (s.closure_kind === "admin_closed") return <span className="ohp-shella is-received" data-testid={testid}>Ditutup Administratif oleh Owner{s.manual ? ` · ${s.manual.by} · ${fmt(s.manual.at)}` : ""}</span>;
  if (s.received_kind === "owner_manual") return <span className="ohp-shella is-received" data-testid={testid}>Diselesaikan Manual oleh Owner · {s.received_by || "-"} · {fmt(s.received_at)} — tanpa penerimaan Shella</span>;
  const man = s.manual && !s.received_at ? <span className="ohp-shella is-scanned" data-testid={`${testid}-manual`}>Diselesaikan Manual oleh Owner · {s.manual.by} · {fmt(s.manual.at)}</span> : null;
  if (man && !s.scanned_at) return man;
  if (s.received_at) return <span className="ohp-shella is-received" data-testid={testid}>Diterima Shella · {s.received_by || "-"} · {fmt(s.received_at)}</span>;
  if (s.scanned_at) return <span className="ohp-shella is-scanned" data-testid={testid}>Dipindai Shella · {s.scanned_by || "-"} · {fmt(s.scanned_at)} — belum diterima</span>;
  return null;
}

export function OfflineHistoryPanel({ onOpen }) {
  const [open, setOpen] = useState(false);
  const [qIn, setQIn] = useState("");
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { const t = setTimeout(() => { setQ(qIn.trim()); setPage(1); }, 350); return () => clearTimeout(t); }, [qIn]);
  useEffect(() => {
    if (!open) return;
    let alive = true;
    setErr("");
    axios.get(`${BASE}/api/production/monitoring/offline-history`, { params: { q, page }, withCredentials: true, timeout: 20000 })
      .then(r => { if (alive) setData(r.data); })
      .catch(e => { if (alive) setErr(e?.response?.data?.detail || "Gagal memuat riwayat — data terakhir dipertahankan."); });
    return () => { alive = false; };
  }, [open, q, page]);
  return <section className="ohp" data-testid="offline-history">
    <button type="button" className="ohp-toggle" onClick={() => setOpen(v => !v)} aria-expanded={open} data-testid="offline-history-toggle">
      <History size={15}/> Riwayat Selesai (diterima Shella / diambil){data ? ` · ${data.total}` : ""}</button>
    {open && <div className="ohp-body">
      <label className="ohp-search"><Search size={14}/><input value={qIn} onChange={e => setQIn(e.target.value)}
        placeholder="Cari nomor nota atau pelanggan" data-testid="offline-history-search"/></label>
      {err && <div className="ohp-err" role="alert">{err}</div>}
      {!data && !err && <div className="ohp-muted">Memuat…</div>}
      {data && data.items.length === 0 && <div className="ohp-muted">Tidak ada riwayat yang cocok.</div>}
      {data?.items.map(r => <button type="button" key={r.order_number} className="ohp-row" onClick={() => onOpen(r.order_number)}
        data-testid={`offline-history-row-${r.order_number}`}>
        <span className="ohp-main"><b>{r.order_number}</b> · {r.customer_name}
          <small>{r.products.map(p => `${p.name} (${p.qty} pcs${p.manual_mode === "admin_close" ? " · Ditutup Administratif" : p.manual_mode ? " · Manual Owner" : ""}${p.done ? "" : ` · ${p.stage || "belum selesai"}`})`).join(" · ")}</small>
          <ShellaStatusLine s={{ received_at: r.received_at, received_by: r.received_by, scanned_at: r.scanned_at, scanned_by: r.scanned_by,
            received_kind: r.received_kind, closure_kind: r.closure_kind, manual: r.manual }}
            testid={`offline-history-shella-${r.order_number}`}/>
          <small>Status nota: {notaLabel(r.order_status)}{r.pickup_status === "Diambil" ? ` · Diambil pelanggan ${fmt(r.picked_up_at)}` : ""}</small></span>
        <ChevronRight size={16}/></button>)}
      {data && data.pages > 1 && <div className="ohp-pager">
        <button type="button" disabled={page <= 1} onClick={() => setPage(p => p - 1)} data-testid="offline-history-prev">Sebelumnya</button>
        <span>{page} / {data.pages}</span>
        <button type="button" disabled={page >= data.pages} onClick={() => setPage(p => p + 1)} data-testid="offline-history-next">Berikutnya</button>
      </div>}
    </div>}
  </section>;
}
